<div class="td-cnt-ext">
    <div class="td-cnt">
        <div class="td-cnt-title">
            <span *ngIf="isLoading" class="te-title">{{ 'enquiryBook.similarEnquiries' | translate}}</span>
            <span *ngIf="!isLoading" class="te-title">{{ (enquiryNo && enquiryNo.length > 0
                ?'enquiryBook.similarEnquiriesAttributes' :
                'enquiryBook.similarEnquiriesProject')
                | translate}}</span>
        </div>
        <div class="td-cnt-body">
            <mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>
            <div *ngIf="!isLoading" style="width: 100%;">
                <p>{{'enquiryBook.foundSimilarEnquiries' | translate: { itemsCount: foundResultsCount} }}</p>
                <teiasoft-grid-odata [columnsToHideGOD]="columnsToHide" [customIcoCols]="customIcoCols"
                    [dataSetRow]="dataSetItems" [columnsToHideRow]="columnsToHideItems"
                    [columnsToShowRow]="columnsToShowRow" (customIconClick)="customIconClick($event)"
                    [calculatedCols]="calculatedCols" [expandedEnquiryNo]="expandedEnquiryNo!" [oDataUrl]="oDataUrl"
                    [odataEntity]="'VEnquiry'" [defaultOdataFilters]="this.oDataFilters" [sortable]="true"
                    style="width:100%;margin-top: 1rem;" [selectable]="false" [enableDoubleClick]="true"
                    [disableAllSelection]="false" [dateFormat]="globals.dateFormat!"
                    [dateTimeFormat]="globals.dateTimeFormat!" [autoWidth]="true" [paginable]="true" [rowsPerPage]="100"
                    [origin]="'enquiry-book'" [rowsPerPage]="15" />
            </div>
        </div>

        <div class="td-cnt-btn" [ngClass]="{'td-cnt-btn-mobile' : isMobile}" *ngIf="!readonly">
            <teiasoft-button *ngIf="projectName && isLoading" (click)="onSkipClick()" [type]="'tb-cancel'"
                [text]="'commons.skip' | translate" [isMobile]="isMobile" class="mr-5"></teiasoft-button>
            <teiasoft-button *ngIf="!isLoading" (click)="onCancelClick()" [type]="'tb-cancel'"
                [text]="'commons.cancelCreation' | translate" [isMobile]="isMobile" class="mr-5"></teiasoft-button>
            <teiasoft-button *ngIf="!isLoading" (click)="onSkipClick()" [type]="'tb-primary'"
                [text]="'commons.createAnyway' | translate" [isMobile]="isMobile"></teiasoft-button>
        </div>
        <div class="td-cnt-btn" [ngClass]="{'td-cnt-btn-mobile' : isMobile}" *ngIf="readonly">
            <teiasoft-button (click)="onCloseClick()" [type]="'tb-cancel'" [text]="'commons.close' | translate"
                [isMobile]="isMobile" class="mr-5"></teiasoft-button>

        </div>
    </div>
</div>